import styled, { css } from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';

import stakingBg from '../../assets/stakingbg.png';

export const NoViewWrapper = styled.div<{
  minWidth?: string;
  bg?: boolean;
}>`
  ${({ minWidth, bg }) => css`
    background-image: ${bg ? `url(${stakingBg})` : 'none'};
    background-size: contain;
    background-repeat: no-repeat;
    ${media.sm`
            min-width: calc(100vw - 60px);
        `}

    ${media.md`
            min-width: ${minWidth || '1000px'};
        `}
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    padding: 40px;
    border-bottom: ${theme.border.style} ${theme.palette.border.default};
  `}
`;

export const Message = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 70px 40px 110px;

  & > * + * {
    margin-top: ${({ theme }) => theme.spacing.unit * 3}px;
  }
`;
